/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const SearchContainer = styled.div`
  padding: 8px 24px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const LoaderWrapper = styled.div`
  width: 100%;
  height: 432px;
  display: flex;
  align-items: center;
  background: ${Palette.PrimaryGray._100};
`;
